import {Component} from '@angular/core';
import {AbstractFieldComponent} from '../_abstract/abstract-field.component';

@Component({
    selector: 'field-date',
    templateUrl: './field-date.component.html',
    styleUrls: [
        './field-date.component.scss'
    ],
    standalone: false
})
export class FieldDateComponent extends AbstractFieldComponent { }
